// extracted by mini-css-extract-plugin
module.exports = {"audio-container":"recordingPannel_audio-container__2ELdi","audio-bar":"recordingPannel_audio-bar__1zwEj","audio-circle":"recordingPannel_audio-circle__3Zb5Y"};